import { useObservable } from 'dexie-react-hooks';
import { useDependency } from 'ditox-react';
import { Refresh } from 'iconsax-react';
import SuccessIndicator from '@/components/settings/debug/success-indicator';
import { WEB_SOCKET_MANAGER_TOKEN } from '@/container';
import { IS_PROD } from '@/utils/constants';
import cn from '@/utils/merge-class-names';

type Props = {
  hideOnProd?: boolean;
  className?: string;
};

export function WebSocketStateIndicator({ hideOnProd = true, className }: Props) {
  const webSocketManager = useDependency(WEB_SOCKET_MANAGER_TOKEN);
  const state = useObservable(webSocketManager.state$);

  if (state === 'connecting') {
    return <span className={cn('loading loading-ring loading-sm m-2 text-base-content/50', className)} />;
  }

  if (state && ['ended', 'closed'].includes(state)) {
    return (
      <button
        type='button'
        className={cn('btn btn-circle btn-ghost btn-sm', className)}
        onClick={() => webSocketManager.reconnect()}>
        <Refresh className='size-5' />
      </button>
    );
  }

  return !(IS_PROD && hideOnProd) ? (
    <SuccessIndicator
      success
      className={cn('desktop:size-full size-6 aspect-square flex flex-center', className)}
    />
  ) : null;
}
